import { fakeFacetCallEN } from './facets/fakeFacetCallEN';
import { fakeFacetCallDE } from './facets/fakeFacetCallDE';
import { fakeProductEN } from './facets/fakeProductEN';
import { fakeProductDE } from './facets/fakeProductDE';

import type { UseProductsState } from '~/composables/useProducts/types';

export const handlePreviewProducts = (state: Ref<UseProductsState>, lang: string) => {
  const { isInEditor } = useEditorState();
  if (!isInEditor.value || state.value.data.products.length > 0) return;

  if (state.value.data.category.type === 'item') {
    const fakeFacetCall = lang === 'de' ? fakeFacetCallDE.data : fakeFacetCallEN.data;

    state.value.data = {
      ...state.value.data,
      category: fakeFacetCall.category,
      facets: fakeFacetCall.facets,
      pagination: fakeFacetCall.pagination,
      languageUrls: fakeFacetCall.languageUrls,
    };
    const fakeProduct = lang === 'de' ? fakeProductDE : fakeProductEN;
    const exampleProductName = lang === 'de' ? 'Beispielprodukt ' : 'Example Product ';

    state.value.data.products = Array.from({ length: 8 }, (_, ind) => ({
      ...fakeProduct,
      texts: {
        ...(fakeProduct.texts ?? {}),
        name1: exampleProductName + (ind + 1),
      },
    }));

    sendFakeDataNotification();
  }
};
